import {
  Row,
  Divider,
  Select,
  Button,
  Typography,
  Space,
  Tag,
  Grid,
} from "antd";
import {
  EnvironmentOutlined,
  GlobalOutlined,
  HomeOutlined,
  DollarOutlined,
  SearchOutlined,
  ClearOutlined,
} from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;

const FiltersBar = ({
  filters,
  handleChange,
  onSearch,
  onClearFilters,
  isAnyFilterActive,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: isMobile ? 20 : 30,
        flexWrap: "wrap",
        gap: isMobile ? 8 : 10,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          borderRadius: 10,
          padding: isMobile ? "12px 8px" : "15px 15px",
          flexWrap: isMobile ? "wrap" : "nowrap",
          justifyContent: "center",
          height: isMobile ? "auto" : 80,
          width: isMobile ? "100%" : "auto",
          gap: isMobile ? "12px" : "0",
        }}
      >
        {/* COUNTRY */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? 6 : 10,
            margin: isMobile ? "4px" : "10px",
            flex: isMobile ? "1 1 45%" : "auto",
            minWidth: isMobile ? "140px" : "auto",
          }}
        >
          <GlobalOutlined
            style={{
              fontSize: isMobile ? 18 : 22,
              color: "#555",
              flexShrink: 0,
            }}
          />
          <div style={{ flex: 1 }}>
            <Text
              style={{
                display: "block",
                fontSize: isMobile ? 10 : 12,
                fontWeight: 600,
                color: "#888",
                marginLeft: isMobile ? "6px" : "10px",
              }}
            >
              COUNTRY
            </Text>
            <Select
              value={filters.country}
              onChange={(value) => handleChange("country", value)}
              style={{ width: isMobile ? "100%" : 180 }}
              bordered={false}
              size={isMobile ? "small" : "middle"}
            >
              <Option value="All">All Countries</Option>
              <Option value="United Arab Emirates">United Arab Emirates</Option>
              <Option value="Saudi Arabia">Saudi Arabia</Option>
              <Option value="Qatar">Qatar</Option>
              <Option value="Kuwait">Kuwait</Option>
            </Select>
          </div>
        </div>

        {!isMobile && (
          <Divider type="vertical" style={{ height: 50, margin: "0 15px" }} />
        )}

        {/* CITY */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? 6 : 10,
            margin: isMobile ? "4px" : "10px",
            flex: isMobile ? "1 1 45%" : "auto",
            minWidth: isMobile ? "120px" : "auto",
          }}
        >
          <EnvironmentOutlined
            style={{
              fontSize: isMobile ? 18 : 22,
              color: "#555",
              flexShrink: 0,
            }}
          />
          <div style={{ flex: 1 }}>
            <Text
              style={{
                display: "block",
                fontSize: isMobile ? 10 : 12,
                fontWeight: 600,
                color: "#888",
                marginLeft: isMobile ? "6px" : "10px",
              }}
            >
              CITY
            </Text>
            <Select
              value={filters.city}
              onChange={(value) => handleChange("city", value)}
              style={{ width: isMobile ? "100%" : 140 }}
              bordered={false}
              size={isMobile ? "small" : "middle"}
            >
              <Option value="All">All Cities</Option>
              <Option value="Dubai">Dubai</Option>
              <Option value="Abu Dhabi">Abu Dhabi</Option>
              <Option value="Sharjah">Sharjah</Option>
            </Select>
          </div>
        </div>

        {!isMobile && (
          <Divider type="vertical" style={{ height: 50, margin: "0 15px" }} />
        )}

        {/* TYPE */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? 6 : 10,
            margin: isMobile ? "4px" : "10px",
            flex: isMobile ? "1 1 45%" : "auto",
            minWidth: isMobile ? "120px" : "auto",
          }}
        >
          <HomeOutlined
            style={{
              fontSize: isMobile ? 18 : 22,
              color: "#555",
              flexShrink: 0,
            }}
          />
          <div style={{ flex: 1 }}>
            <Text
              style={{
                display: "block",
                fontSize: isMobile ? 10 : 12,
                fontWeight: 600,
                color: "#888",
                marginLeft: isMobile ? "6px" : "10px",
              }}
            >
              TYPE
            </Text>
            <Select
              value={filters.type}
              onChange={(value) => handleChange("type", value)}
              style={{ width: isMobile ? "100%" : 120 }}
              bordered={false}
              size={isMobile ? "small" : "middle"}
            >
              <Option value="All">All Types</Option>
              <Option value="Villa">Villa</Option>
              <Option value="Apartment">Apartment</Option>
              <Option value="Building">Building</Option>
              <Option value="Plot">Plot</Option>
              <Option value="Commercial">Commercial</Option>
              <Option value="Office">Office</Option>
            </Select>
          </div>
        </div>

        {!isMobile && (
          <Divider type="vertical" style={{ height: 50, margin: "0 15px" }} />
        )}

        {/* VALUE */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: isMobile ? 6 : 10,
            margin: isMobile ? "4px" : "10px",
            flex: isMobile ? "1 1 45%" : "auto",
            minWidth: isMobile ? "120px" : "auto",
          }}
        >
          <DollarOutlined
            style={{
              fontSize: isMobile ? 18 : 22,
              color: "#555",
              flexShrink: 0,
            }}
          />
          <div style={{ flex: 1 }}>
            <Text
              style={{
                display: "block",
                fontSize: isMobile ? 10 : 12,
                fontWeight: 600,
                color: "#888",
                marginLeft: isMobile ? "6px" : "10px",
              }}
            >
              VALUE
            </Text>
            <Select
              value={filters.value}
              onChange={(value) => handleChange("value", value)}
              style={{ width: isMobile ? "100%" : 120 }}
              bordered={false}
              size={isMobile ? "small" : "middle"}
            >
              <Option value="All">All Prices</Option>
              <Option value="1-10M">1-10M</Option>
              <Option value="10-50M">10-50M</Option>
              <Option value="50M+">50M+</Option>
            </Select>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          gap: isMobile ? "8px" : "10px",
          flexDirection: isMobile ? "row" : "column",
          width: isMobile ? "100%" : "auto",
          justifyContent: isMobile ? "center" : "flex-start",
          marginTop: isMobile ? "10px" : "0",
        }}
      >
        {/* Search Button */}
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={onSearch}
          style={{
            backgroundColor: "#e6a36d",
            border: "none",
            fontWeight: 600,
            height: isMobile ? 45 : 80,
            width: isMobile ? "100%" : 150,
            padding: isMobile ? "0 15px" : "0 25px",
            borderRadius: 8,
            fontSize: isMobile ? "14px" : "16px",
          }}
        >
          Search
        </Button>

        {/* Clear Filters Button - Only show when filters are active */}
        {isAnyFilterActive && (
          <Button
            icon={<ClearOutlined />}
            onClick={onClearFilters}
            style={{
              backgroundColor: "transparent",
              border: "1px solid #d9d9d9",
              color: "#666",
              fontWeight: 500,
              height: isMobile ? 35 : 35,
              padding: isMobile ? "0 12px" : "0 15px",
              borderRadius: 6,
              fontSize: isMobile ? "11px" : "12px",
              width: isMobile ? "auto" : "100%",
              minWidth: isMobile ? "100px" : "auto",
            }}
          >
            Clear
          </Button>
        )}
      </div>

      {/* Active Filters Display */}
      {isAnyFilterActive && (
        <div
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: isMobile ? "10px" : "15px",
            padding: isMobile ? "0 10px" : "0",
          }}
        >
          <Space
            wrap
            style={{ justifyContent: isMobile ? "center" : "flex-start" }}
          >
            <Text
              type="secondary"
              style={{ fontSize: isMobile ? "12px" : "14px" }}
            >
              Active Filters:
            </Text>
            {filters.country !== "All" && (
              <Tag
                color="blue"
                closable
                onClose={() => handleChange("country", "All")}
                style={{
                  fontSize: isMobile ? "11px" : "12px",
                  margin: isMobile ? "2px" : "4px",
                }}
              >
                Country: {filters.country}
              </Tag>
            )}
            {filters.city !== "All" && (
              <Tag
                color="green"
                closable
                onClose={() => handleChange("city", "All")}
                style={{
                  fontSize: isMobile ? "11px" : "12px",
                  margin: isMobile ? "2px" : "4px",
                }}
              >
                City: {filters.city}
              </Tag>
            )}
            {filters.type !== "All" && (
              <Tag
                color="orange"
                closable
                onClose={() => handleChange("type", "All")}
                style={{
                  fontSize: isMobile ? "11px" : "12px",
                  margin: isMobile ? "2px" : "4px",
                }}
              >
                Type: {filters.type}
              </Tag>
            )}
            {filters.value !== "All" && (
              <Tag
                color="red"
                closable
                onClose={() => handleChange("value", "All")}
                style={{
                  fontSize: isMobile ? "11px" : "12px",
                  margin: isMobile ? "2px" : "4px",
                }}
              >
                Price: {filters.value}
              </Tag>
            )}
          </Space>
        </div>
      )}
    </div>
  );
};

export default FiltersBar;
